<template>
  <div class="sidemenu-container">
    <div class="sidemenu-content">
      <FilterBuilder
        :filters="filterConfig"
        :filterType="filterType"
        @filtersChanged="handleFiltersChanged"
      />
    </div>
  </div>
</template>

<script>
import FilterBuilder from '@/components/FilterBuilder.vue';
import { STATUS_OPTIONS } from "@/utils/statusOptions";
import { RECONDUCTION_STATUS_OPTIONS } from "@/utils/reconductionStatusOptions";
import {PAIEMENT_STATUS_OPTIONS} from "@/utils/paiementStatusOptions";

export default {
  name: 'Sidemenu',
  components: { FilterBuilder },
  props: {
    usersList: {
      type: Array,
      default: () => []
    },
    contractTypes: {
      type: Array,
      default: () => ([])
    },
    filterType: {
      type: String,
      default: 'simulation',
      validator: (value) => ['simulation', 'contract'].includes(value)
    },
    customFilterConfig: {
      type: Array,
      default: () => []
    }
  },
  emits: ['filtersChanged'],
  data() {
    return {
      internalFilterConfig: []
    };
  },
  methods: {
    handleFiltersChanged(filters) {
      this.$emit('filtersChanged', filters);
    },
    getDefaultFilterConfig(filterType, usersList, contractTypes) {
      if (filterType === 'contract') {
        return [
          {
            code: 'reference',
            label: 'Référence',
            type: 'input',
            placeholder: 'Saisir une référence'
          },
          {
            code: 'identifier',
            label: 'Identifiant Entreprise',
            type: 'input',
            placeholder: 'Saisir un SIRET ou SIREN'
          },
          {
            code: 'reconduction',
            label: 'Reconduction',
            type: 'select',
            placeholder: 'Sélectionner une reconduction',
            options: RECONDUCTION_STATUS_OPTIONS
          },
          {
            code: 'payment',
            label: 'Paiement',
            type: 'select',
            placeholder: 'Sélectionner un état de paiement',
            options: PAIEMENT_STATUS_OPTIONS
          },
          {
            code: 'startDate',
            label: 'Date de début',
            type: 'datetime',
            placeholder: 'Période de la date de début'
          },
          {
            code: 'endDate',
            label: 'Date de fin',
            type: 'datetime',
            placeholder: 'Période de la date de fin'
          }
        ];
      } else {
        return [
          {
            code: 'reference',
            label: 'Référence',
            type: 'input',
            placeholder: 'Saisir une référence'
          },
          {
            code: 'identifier',
            label: 'Identifiant Entreprise',
            type: 'input',
            placeholder: 'Saisir un SIRET ou SIREN'
          },
          {
            code: 'users',
            label: 'Utilisateurs',
            type: 'multiselect',
            placeholder: 'Filtrer par utilisateur',
            options: usersList
          },
          {
            code: 'contract',
            label: 'Type de contrat',
            type: 'multiselect',
            placeholder: 'Sélectionner un type',
            options: Object.entries(contractTypes).map(([key, value]) => ({
              value: key,
              label: value.label
            }))
          },
          {
            code: 'status',
            label: 'Statut',
            type: 'multiselect',
            placeholder: 'Filtrer par statut',
            options: STATUS_OPTIONS
          },
          {
            code: 'date',
            label: 'Période',
            type: 'datetime',
            placeholder: 'Sélectionner une période'
          },
          {
            code: 'removeSimulation',
            label: 'Dossiers terminés',
            type: 'checkbox',
            placeholder: 'Retirer dossiers terminés',
            tooltip: 'Retirer tous les dossiers terminés'
          }
        ];
      }
    }
  },
  computed: {
    filterConfig() {
      return this.customFilterConfig.length > 0
        ? this.customFilterConfig 
        : this.internalFilterConfig;
    }
  },
  created() {
    this.internalFilterConfig = this.getDefaultFilterConfig(
      this.filterType, 
      this.usersList, 
      this.contractTypes
    );
  },
  watch: {
    filterType(newType) {
      if (this.customFilterConfig.length === 0) {
        this.internalFilterConfig = this.getDefaultFilterConfig(
          newType, 
          this.usersList, 
          this.contractTypes
        );
      }
    },
    usersList: {
      handler(newUsersList) {
        if (this.customFilterConfig.length === 0) {
          this.internalFilterConfig = this.getDefaultFilterConfig(
            this.filterType, 
            newUsersList, 
            this.contractTypes
          );
        }
      },
      deep: true
    },
    contractTypes: {
      handler(newContractTypes) {
        if (this.customFilterConfig.length === 0) {
          this.internalFilterConfig = this.getDefaultFilterConfig(
            this.filterType, 
            this.usersList, 
            newContractTypes
          );
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.sidemenu-container {
  background: #6e398e;
  border-radius: 1rem;
  padding: 1.25rem;
  width: 280px;
  max-width: 90vw;
  border: 4px solid #986dad;
}

.sidemenu-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
</style>